// Helpers e funções puras de Contas a Pagar.
// Extraído de FinanceiroContasPagar.tsx durante refactor topológico.
import { fetchAuthSession } from 'aws-amplify/auth';
import { ColunaKeyCP, ContaPagar, ModoData, ORDEM_STATUS_CP } from './types';
import { faltaPagarCP } from './pagamentosEmPartes';

export async function getToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() ?? '';
}

// Sempre R$ + exatamente 2 casas (maximumFractionDigits fecha o caso de 3+ casas).
export const fmt = (v: number) =>
  'R$ ' + Math.abs(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// F-CP-totais: computa saldo devedor a partir das baixas (pagamentos parciais).
// Se 'pago' ou 'cancelado': 0. Em aberto/agendado: total menos soma das baixas.
// Desde 07/10/2026 a conta é a de pagamentosEmPartes.ts: também olha o
// valor_pago (pago em parte só pelo extrato aparecia com o valor cheio).
export function calcularAPagarCP(c: ContaPagar): number {
  return faltaPagarCP(c);
}

export function dataPrimCP(c: ContaPagar, modoData: ModoData): string {
  if (modoData === 'pagamento') return c.data_pagamento_real || c.data_pagamento || c.data_vencimento || c.data_competencia || '';
  if (modoData === 'vencimento') return c.data_vencimento || c.data_pagamento || c.data_competencia || '';
  return c.data_competencia || c.data_vencimento || c.data_pagamento || '';
}

export function valorSortColunaCP(c: ContaPagar, coluna: ColunaKeyCP, modoData: ModoData): string | number {
  switch (coluna) {
    case 'data':       return dataPrimCP(c, modoData) || '9999-12-31';
    case 'descricao':  return (c.descricao || '').toLowerCase();
    case 'origem':     return c.origem || 'zzz';
    case 'status':     return ORDEM_STATUS_CP[c.status] ?? 99;
    case 'valor':      return Math.abs(c.valor || 0);
    case 'a_pagar':    return calcularAPagarCP(c);
    default:           return '';
  }
}
